var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBtnMainBannerList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon_btn_main_bannerList_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "#000",
  fillOpacity: 0.3,
  rx: 18
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.5 12.5h3.667v3.667H12.5zM12.5 19.833h3.667V23.5H12.5zM19.833 12.5H23.5v3.667h-3.667zM19.833 19.833H23.5V23.5h-3.667z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon_btn_main_bannerList_svg__a",
  width: 76,
  height: 76,
  x: -20,
  y: -20,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_353_18418"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_353_18418",
  result: "shape"
})))));
export default SvgIconBtnMainBannerList;